import React from "react";
import { Tab } from "semantic-ui-react";
import { ListUsersDB } from "../../../../components/Admin/UsersDB";

export function UsersDB() {
  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListUsersDB />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="userdb-page">
      <Tab menu={{ secondary: true }} panes={panes} />
    </div>
  );
}
